import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { OrganizacionService } from './services/organizacion.service';
import { MultiFaResolver } from './resolvers/multi-fa.resolver';
import { YaloService } from './services/yalo.service';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { EstablecimientosService } from './services';
import { ColumnsStorage } from './storage';
import { YaloDataAccessService } from './data-access';
import { ConfigsService } from './services/configs.service';
import { YaloUtilsService } from './services/utils.service';
import { PermissionsService, UserService } from './user';

@NgModule({
  imports: [HttpClientModule],
  exports: [],
  providers: [
    YaloService,
    UserService,
    YaloDataAccessService,
    YaloUtilsService,
    PermissionsService,
    OrganizacionService,
    EstablecimientosService,
    ConfigsService,
    ColumnsStorage,
    MultiFaResolver,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
  ],
})
export class YaloModule {}
